import api from './api/api';

export const findByCaminho = async (caminho) => {
  return api().get(`/publico/documentoCredenciado/findByCaminho?caminho=${caminho}`, {responseType: 'blob'});
}

export const deleteById = async (id) => {
  return api().delete(`/documentoCredenciado/deletar/${id}`);
}
